module.exports = __webpack_public_path__ + "img/tiktok.29d6493f.svg";